import outstanding from "assets/images/app-icons/0.png";
import whatsapp from "assets/images/app-icons/12.png";
import req_therapist from "assets/images/app-icons/1.png";
import treatmentbal from "assets/images/app-icons/2.png";
import birthday from "assets/images/app-icons/3.png";
import new_remark from "assets/images/app-icons/4.png";
import walkin from "assets/images/app-icons/6.png";
import reschedule from "assets/images/app-icons/8.png";
import closeIcon from "assets/images/close.png";
import fullscreenIcon from "assets/images/fullScreen.png";
import refresh from "assets/images/refresh.png";
import setting from "assets/images/settings.png";
import { CredentialConfirmation } from "component/Admin/Cart/credentialConfirmation";
import { TreatmentHistory } from "component/Admin/NewAppointment/NewListAppointment/modal/TreatmentHistory";
import { UpcomingAppointment } from "component/Admin/NewAppointment/NewListAppointment/modal/UpcomingAppointment";
import {
  NormalButton,
  NormalInput,
  NormalModal,
  NormalSelect,
} from "component/common";
import ContextMenu from "devextreme-react/context-menu";
import Scheduler, { Resource, View } from "devextreme-react/scheduler";
import "devextreme/dist/css/dx.common.css";
import "devextreme/dist/css/dx.light.css";
import Button from "devextreme/ui/button";
import { history } from "helpers";
import html2canvas from "html2canvas";
import moment from "moment";
import { SMSReply } from "pages";
import React from "react";
import { withTranslation } from "react-i18next";
import Select from "react-select";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import {
  commonCreateApi,
  commonPatchApi,
  getCommonApi,
} from "redux/actions/common";
import {
  getRescheduleDataApi,
  getRescheduleFullScreenEnb,
  getRescheduleId,
} from "redux/actions/reschedule";
import { getSiteId, getSiteCode } from "redux/actions/appointment";
import { dateFormat } from "service/helperFunctions";
import { Toast } from "service/toast";
import { BlockPopup } from "../../Admin/NewAppointment/NewListAppointment/modal/BlockPopup";
import { PrintModal } from "../../Admin/NewAppointment/NewListAppointment/modal/PrintModal";
import { StaffSorting } from "../../Admin/NewAppointment/NewListAppointment/modal/StaffSorting";
import { AppointmentSettings } from "./devExpressScheduler/AppointmentSettings";
import ResourceCell from "./devExpressScheduler/ResourceCell";
import "./devExpressScheduler/Styles.scss";
import "./style.scss";
import appointment from "redux/reducer/appointment";
import { generateAppointmentStatusPDF } from "./appointmentStatus";

const appointmentClassName = ".dx-scheduler-appointment";
const cellClassName = ".dx-scheduler-date-table-cell";
const groups = ["id"];
var clickeddate = new Date();
const draggingGroupName = "appointmentsGroup";
const sleep = (milliseconds) => {
  return new Promise((resolve) => setTimeout(resolve, milliseconds));
};

let deviceWidth = window.innerWidth;

export function AppointmentMenuTemplate(itemData) {
  return (
    <div>
      {itemData.color ? (
        <div
          className="item-badge"
          style={{ backgroundColor: itemData.color }}
        />
      ) : (
        ""
      )}

      {itemData.text}
    </div>
  );
}

export function handleCellAppointment(data) {
  return <div>{getTime(data.data.date)}</div>;
}

export default function TimeCell(data) {
  return <div>{data}</div>;
}
const scrolling = { mode: "virtual" };
const mobileviews = [
  {
    type: "day",
    name: "day",
    groupOrientation: "Horizontally",
    intervalCount: 1,
    maxAppointmentsPerCell: "unlimited",
  },
];
const views = [
  {
    type: "day",
    name: "day",
    maxAppointmentsPerCell: "unlimited",
  },
  {
    type: "week",
    name: "week",
    maxAppointmentsPerCell: "unlimited",
  },
  {
    type: "month",
    name: "month",
    maxAppointmentsPerCell: "unlimited",
  },
];
const Dayview = [
  {
    type: "day",
    name: "day",
    groupOrientation: "Horizontally",
    intervalCount: 1,
  },
];

const getTime = (date) => {
  var now = new Date(date);
  var hour = now.getHours();
  var minute = now.getMinutes();
  var second = now.getSeconds();
  var ap = "AM";
  if (hour > 11) {
    ap = "PM";
  }
  if (hour > 12) {
    hour = hour - 12;
  }
  if (hour == 0) {
    hour = 12;
  }
  if (hour < 10) {
    hour = "0" + hour;
  }
  if (minute < 10) {
    minute = "0" + minute;
  }
  if (second < 10) {
    second = "0" + second;
  }
  var timeString = hour + ":" + minute + " " + ap;
  return timeString;
};

export const resourcesData = [
  {
    text: "Room 101",
    id: 1,
    color: "#bbd806",
  },
  {
    text: "Room 102",
    id: 2,
    color: "#f34c8a",
  },
  {
    text: "Room 103",
    id: 3,
    color: "#ae7fcc",
  },
  {
    text: "Meeting room",
    id: 4,
    color: "#ff8817",
  },
  {
    text: "Conference hall",
    id: 5,
    color: "#03bb92",
  },
];

export class NewSchedulerModalClass extends React.Component {
  constructor(props) {
    super(props);
    this.scheduler = React.createRef();
    this.selectContainerRef = React.createRef();
    this.state = {
      selectedDate: new Date(),
      selectedView: "",
      DefaultDate: new Date(),
      DefaultView: "",
      searchtext: "",
      SelectedList: [],
      isOpenModal: false,
      isOpenBlockModal: false,
      appointmentId: 0,
      SchedulerHeight: "100%",
      isOpenPrintModal: false,
      formFields: [],
      groupByList: [
        { label: "Group by Staff", value: "staff" },
        { label: "Group by Department", value: "department" },
        { label: "Group by Room", value: "room" },
      ],
      groupBy: "staff",
      customerNumber: 0,
      customerId: 0,
      clickCount: 0,
      visible: false,
      customerOption: [],
      isSettingsClick: false,
      dayName: [
        "Sunday",
        "Monday",
        "Tuesday",
        "Wednesday",
        "Thursday",
        "Friday",
        "Saturday",
      ],
      day: new Date().getDay(),
      passwordVisible: false,
      dragusername: "",
      dragpassword: "",
      isDragConfirmation: false,
      isSMSReply: false,
      isScrolled: false,
      contextMenuItems: [],
      target: appointmentClassName,
      disabled: true,
      statusListData: [],
      isAppointmentLogConfirmation: false,
      appointmentCellData: {},
      rescheduleLocalData: "",
      fullScreenEnabled: false,
      flgAppointmentView: true,
      hideRow: true,
      hideBtnStatus: true,
      isLoginConfirmation: false,
      siteList: [],
      branch_id: null,
      zIndex: 100,
      openAppointmentStatusPopup: false,
      appointmentStatusDetails: [],
      appointmentDate: "",
    };
    this.onAppointmentContextMenu = this.onAppointmentContextMenu.bind(this);
    this.onContextMenuItemClick = this.onContextMenuItemClick.bind(this);
    this.onCellContextMenu = this.onCellContextMenu.bind(this);
  }

  componentDidMount = async () => {
    window.addEventListener("scroll", this.handleScroll);

    this.props.getSiteId(this.props.tokenDetail.logined_siteid);
    this.props.getSiteCode(this.props.tokenDetail.site_code);
    let { siteList } = this.state;
    for (let key of this.props.tokenDetail.switch_sites) {
      siteList.push({
        label: key.itemsite_desc,
        value: key.id,
        siteCode: key.itemsite_code,
      });
    }
    await this.setState({
      DefaultDate: this.props.filterDate,
      DefaultView: this.props.filterType,
      siteList,
      branch_id: this.props.tokenDetail.logined_siteid,
    });

    this.props.getCommonApi("bookingstatus/").then((res) => {
      let { status, data, sec_data } = res;
      if (status === 200) {
        this.setState({ statusListData: data });
      }
    });
    window.addEventListener("scroll", this.handleScroll);
    console.log(this.props.tokenDetail, "tokenDetail");
  };
  // onAppointmentContentMenu
  onAppointmentContextMenu(e) {
    console.log(e.appointmentData, "appointementdata");
    let mapData = this.state.statusListData.map((item) => {
      return {
        text: item.label,
        onItemClick: () =>
          this.handleToUpdateStatus(e.appointmentData.appt_id, item.value),
        label: item.label,
        color: item.color,
      };
    });

    let appointmentStatusCheck = false;
    if (e.appointmentData.status !== "Block") {
      appointmentStatusCheck = true;
    }

    if (appointmentStatusCheck) {
      mapData.push({
        text: "Reschedule",
        onItemClick: () => this.handleRescheduleCopy(e),
        label: "Reschedule",
        color: "#42e2c7",
      });
    }
    this.setState((state) => ({
      ...state,
      target: appointmentClassName,
      disabled: false,
      contextMenuItems: mapData,
    }));
    e.cancel = true;
  }

  // onCellContextMenu-click cenll event
  onCellContextMenu(e) {
    this.setState((state) => ({
      ...state,
      target: cellClassName,
      disabled: false,
      contextMenuItems: [
        {
          text: "Reschedule Apply here",
          onItemClick: () => this.handleToCheckValidate(e),
          label: "Reschedule",
          color: "#42e2c7",
        },
      ],
    }));
    e.cancel = true;
  }

  // handleReschedule
  handleRescheduleCopy = async (e) => {
    let id = e.appointmentData.appt_id;
    let formFields = {};
    formFields["appointmentId"] = id;
    if (new Date(e.appointmentData.endDate, "DD/MM/YYYY") < new Date()) {
      Toast({
        type: "error",
        message: "Past date appointment is not allowed",
      });
      return false;
    } else {
      // setrescheduleId in redux
      await this.props.getRescheduleId("RescheduleId", formFields);
      await this.props.getRescheduleDataApi(
        "RescheduleData",
        e.appointmentData
      );
      Toast({ type: "success", message: "Selected For Reschedule" });
    }
  };

  //handleToCheckValidate
  handleToCheckValidate = (e) => {
    this.setState({ appointmentCellData: e.cellData }, () => {
      if (this.props.tokenDetail.apptedit_pw) {
        this.setState({ isAppointmentLogConfirmation: true });
      } else {
        this.handleReschedulePaste();
      }
    });

    // this.handleReschedulePaste(e);
  };

  handleScroll = () => {
    // You can adjust this threshold as needed
    const scrollThreshold = 100; // Example threshold value
    if (window.scrollY >= scrollThreshold) {
      if (!this.state.isScrolled) {
        this.setState({ isScrolled: true, zIndex: 1 });
      }
    } else {
      if (this.state.isScrolled) {
        this.setState({ isScrolled: false, zIndex: 10 });
      }
    }
  };

  componentWillUnmount() {
    // Remove the scroll event listener when the component is unmounted
    window.removeEventListener("scroll", this.handleScroll);
  }

  // handleReschedulePaste

  // handleToPastRescheduleData
  handleReschedulePaste = (user, pass) => {
    let { rescheduleId } = this.props;
    let { startDate, endDate, groups } = this.state.appointmentCellData;
    let todayDate = moment(new Date()).format("YYYY/MM/DD");
    let selectedDate = moment(startDate).format("YYYY/MM/DD");
    let beforeDate = moment(selectedDate).isBefore(todayDate, "days");
    if (beforeDate) {
      Toast({ type: "error", message: "Past date appointment is not allowed" });
    } else {
      if (rescheduleId) {
        this.props
          .getCommonApi(
            `appointmentedit/${rescheduleId.appointmentId}/?site_select=${this.props.siteId}`
          )
          .then(async (key) => {
            let { status, data } = key;
            console.log("data", "rescheduledaddd");
            debugger;

            this.setState({
              rescheduleLocalData: data,
            });

            if (status === 200) {
              let finalTreatment = [];
              for (let TreatmentList of data.treatment) {
                finalTreatment.push({
                  appt_id: TreatmentList.appt_id,
                  start_time: this.getHoursFromDate(startDate),
                  end_time: this.getHoursFromDate(endDate),
                  add_duration: TreatmentList.add_duration,
                  item_id: TreatmentList.item_id,
                  item_text: TreatmentList.item_text ?? "",
                  emp_id: groups.id,
                  requesttherapist: TreatmentList.requesttherapist,
                  recur_qty: TreatmentList.recur_qty,
                  recur_days: TreatmentList.recur_days,
                  checktype: TreatmentList.checktype,
                  treat_parentcode: TreatmentList.treat_parentcode,
                });
              }

              let payload = {
                appointment: {
                  appt_date: dateFormat(new Date(startDate), "yyyy-mm-dd"),
                  appt_status: data.appointment.appt_status,
                  channel_id: Number(data.appointment.channel_id),
                  cust_noid: data.appointment.cust_id,
                  ori_remark: data.appointment.ori_remark,
                  source_id: Number(data.appointment.source_id),
                  Room_Codeid: Number(data.appointment.Room_Codeid),
                  sec_status: data.appointment.sec_status,
                  remark_setting: data.appointment.remark_setting,
                  cart_create: "",
                  apptdel_id: [],
                  cust_StoreCard: data.appointment.cust_StoreCard,
                  bookedby: data.appointment.bookedby,
                  editedby: data.appointment.editedby,
                },
                treatment: finalTreatment,
              };
              if (user) payload.appointment.username = user ?? "";
              if (pass) payload.appointment.password = pass ?? "";
              this.props
                .commonPatchApi(
                  `appointmentedit/${rescheduleId.appointmentId}/`,
                  payload
                )
                .then(async (res) => {
                  if (res.status === 200) {
                    this.setState({ isAppointmentLogConfirmation: false });
                    this.props.getAppointmentWithStaff();

                    // clear RescheduleId in redux
                    this.props.getRescheduleId("RescheduleId", "");
                    this.props.getRescheduleDataApi("RescheduleData", "");
                  }
                });
            }
          });
      }
    }
  };

  // handleToUpdateStatus

  handleToUpdateStatus = (id, status) => {
    if (id) {
      let body = {
        appt_id: id,
        appt_status: status,
      };
      this.props
        .commonCreateApi("appointment/statusupdate/", body)
        .then((res) => {
          let { status } = res;
          if (status === 200) {
            this.props.getAppointmentWithStaff();
            // window.location.reload();
          }
        });
    }
  };

  onContextMenuItemClick(e) {
    e.itemData.onItemClick(e);
  }

  //Added by Santhosh
  //handleSelectSite
  handleSiteList = (e) => {
    let { siteList } = this.state;
    const selectedId = parseInt(e.target.value);
    const selectedSite = siteList.find((site) => site.value === selectedId);
    this.props.getSiteId(e.target.value);
    console.log(selectedSite.siteCode, "siteCode");
    this.props.getSiteCode(selectedSite.siteCode);
    this.setState(
      {
        branch_id: e.target.value,
      },
      () => {
        this.props.getAppointmentWithStaff();
        console.log(this.state.branch_id, "NewBranch");
      }
    );
  };

  // userClick emptyCell when this function called
  onEmptyClick = (e) => {
    e.cancel = true;
    let date = new Date(e.cellData.startDate);
    clickeddate = date;
    if (e.cellData.groups) {
      this.props.onEmptyClick(date, e.cellData);
    }
  };

  onAppointmentDblClick = async (e) => {
    e.cancel = true;
    // Added by Santhosh
    const isEnable = e.appointmentData.itemsite_code === this.props.siteCode;
    // Disabling the condition to allow edit block appointment
    // if (isEnable) {
    this.setState({
      appointmentId: 0,
    });
    let date = new Date(e.appointmentData.startDate);
    clickeddate = date;
    if (e.appointmentData.status === "Block") {
      this.setState({ appointmentId: e.appointmentData.appt_id });
      this.handleBlockDialog();
    } else {
      this.props.onEmptyClick(date, e.appointmentData);
      this.setState({
        customerId: e.appointmentData.cust_id,
        custName: e.appointmentData.cust_name,
        custPhone: e.appointmentData.cust_phone,
      });
    }
    // }
  };

  onAppointmentSingleClick = async (e) => {
    console.log(e.appointmentData, "eAppointment");
    e.cancel = true;
    if (e.appointmentData.status !== "Block") {
      this.setState({
        customerId: e.appointmentData.cust_id,
        custName: e.appointmentData.cust_name,
        custPhone: e.appointmentData.cust_phone,
      });
    }
  };

  handleViewChange = async (e) => {
    //if (this.props.staffList.length > 0) {
    await this.setState({
      selectedView: e,
    });
    this.handleChange();
    //}
  };

  handleDateChange = async (e) => {
    let { day } = this.state;
    if (this.state.selectedDate !== e) {
      await this.setState({
        selectedDate: e,
      });
      this.handleChange();
    }
    day = moment(this.state.selectedDate).day();
    this.setState({ day });
    console.log(day);
  };

  handleChange = () => {
    let { selectedDate, selectedView, DefaultDate, DefaultView, searchtext } =
      this.state;
    let newDate = new Date();
    let newMode = "";
    let prevMode = DefaultView;
    let prevDate = DefaultDate;
    if (selectedView) {
      newMode = selectedView;
    } else {
      newMode = DefaultView;
    }
    if (selectedDate) {
      newDate = selectedDate;
    } else {
      newDate = selectedDate;
    }
    this.props.handleChangeFilter(
      prevMode,
      prevDate,
      newMode,
      newDate,
      searchtext
    );
  };
  onContentReady(e) {
    console.log(e, "onContentReady");

    //Yoonus removed them and added last line
    //const currentHour = new Date().getHours() - 1;
    //e.component.scrollToTime(currentHour, 30, new Date());
    ////e.component.scrollToTime(currentHour, 30, new Date(thisDate.Date ));
    //let date = new Date(e.cellData.startDate);
    //console.log(clickeddate);
    //console.log(clickeddate.getHours());
    e.component.scrollTo(
      clickeddate.getHours(),
      clickeddate.getMinutes(),
      clickeddate
    );
  }
  onContentReadyDouble(e) {
    console.log(e, "onContentReadyDouble");
    const currentHour = new Date().getHours() - 1;
    //Yoonus remove
    //e.component.scrollToTime(currentHour, 30, new Date());

    const SMSreplyButton = document.getElementById("schedulerSMSreplyButton");
    if (!SMSreplyButton) {
      let element = document.querySelectorAll(".dx-scheduler-navigator");
      const container = document.createElement("div");
      container.id = "schedulerSMSreplyButton";
      element[0].appendChild(container);

      new Button(container, {
        text: "SMS Reply",
        mainbgrev: true,
        onClick: () => history.push("/admin/newappointment/SMSReply"),
        className: "ml-5 mr-3",
      });
    }

    const schedulerConfirmButton = document.getElementById(
      "schedulerConfirmButton"
    );
    if (!schedulerConfirmButton) {
      let element = document.querySelectorAll(".dx-scheduler-navigator");
      const containerTwo = document.createElement("div");
      containerTwo.id = "schedulerConfirmButton";
      element[0].appendChild(containerTwo);
      new Button(containerTwo, {
        text: "Confirm Booking",
        onClick: () => history.push("/admin/newappointment/confirmbooking"),
        mainbgrev: true,
        style: "display:flex",
        className: "ml-5 mr-5",
      });
    }
  }

  onContentReadysms(e) {
    console.log(e, "onContentReadysms");
    const currentHour = new Date().getHours() - 1;
    //Yoonus remove
    //e.component.scrollToTime(currentHour, 30, new Date());

    const SMSreplyButton = document.getElementById("schedulerSMSreplyButton");
    if (!SMSreplyButton) {
      let element = document.querySelectorAll(".dx-scheduler-navigator");
      const container = document.createElement("div");
      container.id = "schedulerSMSreplyButton";
      element[0].appendChild(container);

      new Button(container, {
        text: "SMS Reply",
        mainbgrev: true,
        onClick: () => history.push("/admin/newappointment/SMSReply"),
        className: "ml-5 mr-3",
      });
    }
  }
  onContentReadyconfirmbook(e, appointmentData) {
    if (appointmentData) {
      let { startDate, endDate, cust_name, cust_code, cust_phone, staff } =
        appointmentData;
      let mergeData =
        dateFormat(new Date(startDate), "dd-mm-yyyy") +
        " " +
        getTime(startDate) +
        "-" +
        getTime(endDate) +
        " " +
        "</br>" +
        cust_name +
        " " +
        cust_code +
        " " +
        cust_phone +
        "</br>" +
        staff;

      const schedulerHeaderHgt = document.querySelector(
        "div.dx-scheduler-header"
      );
      schedulerHeaderHgt.classList.add("schedulerHeaderHgt");

      var getNavigationData =
        document.getElementsByClassName("dx-toolbar-center");
      const newDiv = document.createElement("div");
      newDiv.className = "parentView";

      let contentPara = document.createElement("p");
      let titleHeading = document.createElement("p");
      titleHeading.innerHTML = "reschedule appointment";
      titleHeading.className = "rescheduleBoxTitle";
      contentPara.innerHTML = mergeData;
      let removeText = document.createElement("p");
      removeText.innerHTML = "Remove";
      removeText.className = "removeTextHighlight";
      removeText.addEventListener("click", this.handleToCallRemove);
      newDiv.appendChild(titleHeading);
      newDiv.appendChild(contentPara);
      newDiv.appendChild(removeText);

      getNavigationData[0].appendChild(newDiv);

      // getNavigationData[1].appendChild(newDiv1);
    } else {
      const schedulerHeaderHgt = document.querySelector(
        "div.dx-scheduler-header"
      );
      schedulerHeaderHgt.classList.remove("schedulerHeaderHgt");
    }

    const currentHour = new Date().getHours() - 1;
    //Yoonus remove
    //e.component.scrollToTime(currentHour, 30, new Date());
    if (this.props.tokenDetail?.confirmbook) {
      const schedulerConfirmButton = document.getElementById(
        "schedulerConfirmButton"
      );
      if (!schedulerConfirmButton) {
        let element = document.querySelectorAll(".dx-scheduler-navigator");
        const containerTwo = document.createElement("div");
        containerTwo.id = "schedulerConfirmButton";
        element[0].appendChild(containerTwo);
        new Button(containerTwo, {
          text: "Confirm Booking",
          onClick: () => history.push("/admin/newappointment/confirmbooking"),
          mainbgrev: true,
          style: "display:flex",
          className: "ml-5 mr-5",
        });
      }
    } else {
      this.onContentReady(e);
    }
  }

  // handleToAddBtn
  handleToAddBtn = () => {
    var headerHide = document.getElementsByClassName("dx-toolbar-before");
    const hideDiv = document.createElement("div");
    hideDiv.className = "hideSettingParent btn cursor-pointer mainbg-btn";
    let titleHeading1 = document.createElement("p");
    titleHeading1.innerHTML = this.state.hideRow ? "Hide Tools" : "Show Tools";
    hideDiv.appendChild(titleHeading1);
    hideDiv.addEventListener("click", this.handleToHideRow);
    headerHide[0].appendChild(hideDiv);
  };

  // handleToHideRow
  handleToHideRow = async () => {
    await this.setState((prevState) => ({
      hideRow: !prevState.hideRow,
    }));
  };

  // handleToRemoveData
  handleToCallRemove = () => {
    this.props.getRescheduleId("RescheduleId", "");
    this.props.getRescheduleDataApi("RescheduleData", "");
  };

  handleSearch = async (event) => {
    event.persist();
    await this.setState({ searchtext: event.target.value });
    //Yoonus blocking this
    //if (!this.debouncedFn) {
    //  this.debouncedFn = _.debounce(() => {
    //    this.handleChange();
    //  }, 500);
    //}
    //this.debouncedFn();
    //Yoonus blocking this
  };
  handleDragConfirmationDialog = async () => {
    let { isDragConfirmation } = this.state;
    isDragConfirmation = !isDragConfirmation;
    await this.setState({
      isDragConfirmation,
    });
    await this.props.getAppointmentWithStaff();
  };
  handleDialog = () => {
    let { isOpenModal } = this.state;
    isOpenModal = !isOpenModal;
    this.setState({
      isOpenModal,
    });
  };
  handleSettingDialog = () => {
    let { isSettingsClick } = this.state;
    isSettingsClick = !isSettingsClick;
    this.setState({
      isSettingsClick,
    });
  };
  handleBlockDialog = async () => {
    this.setState((prevState) => ({
      isOpenBlockModal: !prevState.isOpenBlockModal,
    }));
    this.setState({ appointmentId: 0 });
  };
  handlePrintDialog = () => {
    let { isOpenPrintModal } = this.state;
    isOpenPrintModal = !isOpenPrintModal;
    this.setState({
      isOpenPrintModal,
    });
  };

  handleBack = () => {
    this.props.handleBack();
  };
  handleNext = () => {
    this.props.handleNext();
  };
  Snap = async () => {
    // await this.setState({
    //   SchedulerHeight: "350%",
    // });
    //await sleep(2000); //
    //window.scrollTo(0, 0);
    let img = "";
    let base64URL = "";

    html2canvas(document.querySelector(".dx-scheduler-work-space-grouped"), {
      allowTaint: true,
      useCORS: true,
      logging: false,
      scale: 1,
      removeContainer: false,
    }).then(function (canvas) {
      img = canvas.toDataURL("image/png", 1);
      base64URL = img.replace("image/png", "image/octet-stream");
      var byteCharacters = atob(
        img.replace(/^data:image\/(png|jpeg|jpg);base64,/, "")
      );
      var byteNumbers = new Array(byteCharacters.length);
      for (var i = 0; i < byteCharacters.length; i++) {
        byteNumbers[i] = byteCharacters.charCodeAt(i);
      }
      var byteArray = new Uint8Array(byteNumbers);
      var file = new Blob([byteArray], { type: "image/png" + ";base64" });
      var fileURL = URL.createObjectURL(file);
      var a = document.createElement("a");
      a.setAttribute("download", "myImage.png");
      a.setAttribute("href", base64URL);
      a.click();
      window.open(fileURL);
    });
    //window.scrollTo(0, document.documentElement.scrollHeight);
    this.setState({
      SchedulerHeight: "100%",
    });
  };

  getHoursFromDate = (date) => {
    let hour = new Date(date).getHours();
    let minute = new Date(date).getMinutes();
    let hours = hour > 9 ? hour : "0" + hour;
    let minutes = minute > 9 ? minute : "0" + minute;
    return hours + ":" + minutes;
  };
  // onDragStart = async e => {
  //   if (e.itemData.status === "Block") {
  //     e.cancel = true;
  //   } else {
  //     await sleep(300);
  //     this.getDraggedData(e.itemData.appt_id);
  //   }
  // };
  onDragStart = async (e) => {
    console.log(e.itemData.itemsite_code, "drag start data");
    // Added (isEnable) by Santhosh
    const isEnable = e.itemData.itemsite_code === this.props.siteCode;

    // commented the isEnable condition for other site appointment Drag
    if (
      String(e.itemData.status).toUpperCase() === "BLOCK"
      // || String(e.itemData.status).toUpperCase() === "CANCELLED" 
      //Yoonus LEt Mirage drag cancel
      //|| String(e.itemData.status).toUpperCase() === "WAITING"
      // Yoonus removing waiting from this list on 27122024 for kenko whatsapp flow
      // !isEnable
    ) {
      //debugger;
      e.cancel = true;
      // if (!isEnable) {
      //   Toast({
      //     type: "error",
      //     message: "Other Site Appointment is not allowed to drag",
      //   });
      // } else {
      Toast({
        type: "error",
        message: "Appointment not allowed for dragging",
      });
    }
    // return false;
    // }
    // else if (e.itemData.link_flag) {
    //   //debugger;
    //   e.cancel = true;
    //   Toast({
    //     type: "error",
    //     message: "Appointment not allowed for dragging",
    //   });
    //   return false;
    // }
  };

  onDragEnd = async (e) => {
    //await sleep(500);

    if (e.itemData.appt_id) {
      let { formFields, isDragConfirmation } = this.state;
      let startTime = this.getHoursFromDate(e.itemData.startDate);
      let endTime = this.getHoursFromDate(e.itemData.endDate);
      let targetStaff = e.itemData.id;
      // Added by Santhosh (?site_select=${this.props.siteId})
      this.props
        .getCommonApi(
          `appointmentresources/${e.itemData.appt_id}/?site_select=${this.props.siteId}`
        )
        .then(async (key) => {
          let { status, data } = key;
          console.log(key, "drag end data response");
          let appt_Date = data.appt_date;
          let date = appt_Date.split("/");
          let finaldate = date[2] + "-" + date[1] + "-" + date[0];
          if (status === 200) {
            formFields["appt_id"] = e.itemData.appt_id;
            formFields["custName"] = data.cust_name;
            formFields["appointmentDate"] = finaldate;
            formFields["bookingStatus"] = data.booking_status;
            formFields["new_remark"] = data.ori_remark;
            formFields["customerName"] = data.cust_id;
            formFields["Source_Codeid"] = data.source_id;
            formFields["Room_Codeid"] = data.room_id;
            formFields["sec_status"] = data.secondary_status;
            formFields["Appt_typeid"] = data.channel_id;

            formFields["start_time"] = data ? data.start_time : "";
            formFields["end_time"] = data ? data.end_time : "";
            formFields["Item_Codeid"] = data.Item_Codeid;
            formFields["Item_CodeName"] = data.item_name;
            formFields["emp_no"] = data.emp_id;
            formFields["add_duration"] = data.add_duration;
            formFields["edit_remark"] = "";
            formFields["requesttherapist"] = data.requesttherapist;
            formFields["recur_days"] = data.recur_days;
            formFields["recur_qty"] = data.recur_qty;
            formFields["item_text"] = data.item_name;

            if (
              formFields["start_time"] !== startTime ||
              formFields["emp_no"] !== targetStaff
            ) {
              formFields["appointmentDate"] = e.itemData.endDate;
              formFields["start_time"] = startTime;
              formFields["end_time"] = endTime;
              formFields["emp_no"] = targetStaff;
              formFields["item_text"] = e.itemData.item_name;
              formFields["recur_days"] = null;
              formFields["recur_qty"] = null;
              console.log(data.appointmentpassword);
              if (data.appointmentpassword) {
                //data.is_dragappt Yoonus changed to appointmentpassword
                isDragConfirmation = true;
                this.setState({ formFields, isDragConfirmation });
              } else {
                isDragConfirmation = false;
                this.setState({ formFields, isDragConfirmation });
                this.handleDragandDropLogin();
              }
            }
          }
        });
    }
  };

  handleTreatmentHistory = () => {
    let { customerId } = this.state;
    if (customerId > 0) {
      this.setState((prevState) => ({
        isTreatmentHistoryModal: !prevState.isTreatmentHistoryModal,
        customerNumber: this.state.customerId,
      }));
    } else {
      Toast({ type: "error", message: "Please select customer" });
    }
  };
  handleUpcomingAppointment = () => {
    let { customerId } = this.state;
    if (customerId > 0) {
      this.setState((prevState) => ({
        isUpcomingAppointmentModal: !prevState.isUpcomingAppointmentModal,
        customerNumber: this.state.customerId,
      }));
    } else {
      Toast({ type: "error", message: "Please select customer" });
    }
  };
  handleSearchCustomer = async (event) => {
    //    event.persist();
    let { custName } = this.state;
    custName = event.target.value;
    this.setState({ custName });
    // console.log(this.state.custName);
    // if (!this.debouncedFn) {
    //   this.debouncedFn = _.debounce(async () => {
    //     let { customerList } = this.state;
    //     let { basicApptDetail } = this.props;
    //     this.search(basicApptDetail);
    //   }, 500);
    // }
    // this.debouncedFn();
  };

  handleIconSearch = () => {
    this.setState({ visible: true });
    let { basicApptDetail } = this.props;
    this.search(basicApptDetail);
  };

  search = (basicApptDetail) => {
    let { custName } = this.state;
    this.props
      .getCommonApi(
        `custappt/?Outlet=${
          basicApptDetail.branchId ? basicApptDetail.branchId : ""
        }&search=${custName}`
      )
      .then((key) => {
        // this.props.getCommonApi(`custappt/?search=${custName}`).then(key => {
        let { status, data } = key;
        if (status === 200) {
          this.setState({ customerOption: data });
        }
      });
  };
  handleClick = (key) => {
    if (!this.state.visible) {
      document.addEventListener("click", this.handleOutsideClick, false);
    } else {
      document.removeEventListener("click", this.handleOutsideClick, false);
    }

    if (this.state.visible) {
      let { basicApptDetail } = this.props;
      this.search(basicApptDetail);
    }
    this.setState((prevState) => ({
      visible: !prevState.visible,
    }));
  };
  handleSettingClick = (key) => {
    this.setState((prevState) => ({
      isSettingsClick: !prevState.isSettingsClick,
    }));
  };

  handleOutsideClick = (e) => {
    if (this.node != null) {
      if (this.node.contains(e.target)) {
        return;
      }
    }
    this.handleClick();
  };
  handleSelectCustomer = async (data) => {
    console.log(data, "selectCustomer");
    this.setState({
      customerId: data.id,
      custName: data.cust_name,
      custPhone: data.cust_phone2, //Yoonus data.cust_phone1 to data.cust_phone2
    });
    this.handleClick();
  };
  handleGroupbyChange = async ({ target: { value, name } }) => {
    if (value == "") {
      value = "staff";
    }
    if (value !== this.state.groupBy) {
      this.setState({
        groupBy: value,
      });
      this.props.groupByAppointment(value);
    }
  };
  handleFullScreenClose = () => {
    this.props.getRescheduleFullScreenEnb("fullScreenEnabled", "false");
    history.push("/admin/newappointment");
    this.setState({ SchedulerHeight: "65%", fullScreenEnabled: false });
  };
  handleFullScreenOpen = () => {
    this.props.getRescheduleFullScreenEnb("fullScreenEnabled", "true");
    history.push("/admin/newappointmentfullscreen");
    this.setState({ SchedulerHeight: "100%", fullScreenEnabled: true });
  };

  handleInputChange = async (event) => {
    this.setState({
      [event.target.name]: event.target.value,
    });
  };
  toggle = (key) => {
    this.setState((prevState) => ({
      [key]: !prevState[key],
    }));
  };

  handleDragandDropLogin = () => {
    let { formFields, dragusername, dragpassword } = this.state;
    let payload = {
      appt_date: dateFormat(new Date(formFields.appointmentDate), "yyyy-mm-dd"),
      Room_Codeid: formFields.Room_Codeid,
      appt_status: formFields.bookingStatus,
      sec_status: formFields.sec_status,
      edit_remark: "",
      start_time: formFields.start_time,
      end_time: formFields.end_time,
      item_id: formFields.Item_Codeid,
      add_duration: formFields.add_duration,
      emp_id: formFields.emp_no,
      requesttherapist: formFields.requesttherapist,
      item_text: formFields.item_text,
      recur_qty: null,
      recur_days: null,
      username: dragusername,
      password: dragpassword,
      // Added by Santhosh
      site_select: Number(this.props.siteId),
    };

    this.props
      .commonPatchApi(`appointmentresources/${formFields.appt_id}/`, payload)
      .then(async (res) => {
        this.setState({
          isDragConfirmation: false,
        });
        //this.props.getAppointmentWithStaff();
      });
  };

  handleSMSReply = async () => {
    await this.setState((prevState) => ({
      isSMSReply: !prevState.isSMSReply,
    }));
  };

  onAppointmentUpdated = async (e) => {
    let selecteddata = e;
    let date = new Date(selecteddata.newData.startDate);
    clickeddate = date;

    if (selecteddata.newData) {
      //Yoonus removing cancelled and waiting
      //if (
      //  String(selecteddata.newData.status).toUpperCase() === "BLOCK" ||
      //  String(selecteddata.newData.status).toUpperCase() === "CANCELLED" ||
      //  String(selecteddata.newData.status).toUpperCase() === "WAITING"
      //) {
      if (String(selecteddata.newData.status).toUpperCase() === "BLOCK") {
        e.cancel = true;
        Toast({
          type: "error",
          message: "Block is Not allowed to drag",
        });
        this.props.getAppointmentWithStaff();
        return false;
      } else if (selecteddata.newData.link_flag) {
        e.cancel = true;
        Toast({
          type: "error",
          message: "Linked appointment is Not allowed to drag",
        });
        this.props.getAppointmentWithStaff();
        return false;
      } else {
        console.log(selecteddata, "onResizeEnd");
        this.onResizeEnd(selecteddata);
      }
    }
  };

  onResizeEnd = async (e) => {
    if (e.newData.appt_id) {
      let { formFields, isDragConfirmation } = this.state;
      let startTime = this.getHoursFromDate(e.newData.startDate);
      let endTime = this.getHoursFromDate(e.newData.endDate);
      let targetStaff = e.newData.id;
      // Added by Santhosh (?site_select=${this.props.siteId})
      this.props
        .getCommonApi(
          `appointmentresources/${e.newData.appt_id}/?site_select=${this.props.siteId}`
        )
        .then(async (key) => {
          let { status, data } = key;
          console.log(key, "resize data response");
          let appt_Date = data.appt_date;
          let date = appt_Date.split("/");
          let finaldate = date[2] + "-" + date[1] + "-" + date[0];
          if (status === 200) {
            formFields["appt_id"] = e.newData.appt_id;
            formFields["custName"] = data.cust_name;
            formFields["appointmentDate"] = finaldate;
            formFields["bookingStatus"] = data.booking_status;
            formFields["new_remark"] = data.ori_remark;
            formFields["customerName"] = data.cust_id;
            formFields["Source_Codeid"] = data.source_id;
            formFields["Room_Codeid"] = data.room_id;
            formFields["sec_status"] = data.secondary_status;
            formFields["Appt_typeid"] = data.channel_id;

            formFields["start_time"] = data ? data.start_time : "";
            formFields["end_time"] = data ? data.end_time : "";
            formFields["Item_Codeid"] = data.Item_Codeid;
            formFields["Item_CodeName"] = data.item_name;
            formFields["emp_no"] = data.targetStaff;
            formFields["add_duration"] = null;
            formFields["edit_remark"] = "";
            formFields["requesttherapist"] = data.requesttherapist;
            formFields["recur_days"] = data.recur_days;
            formFields["recur_qty"] = data.recur_qty;
            formFields["item_text"] = data.item_name;

            if (
              formFields["start_time"] !== startTime ||
              formFields["end_time"] !== endTime ||
              formFields["emp_no"] !== targetStaff
            ) {
              formFields["appointmentDate"] = e.newData.endDate;
              formFields["start_time"] = startTime;
              formFields["add_duration"] = null;
              formFields["end_time"] = endTime;
              formFields["emp_no"] = targetStaff;
              formFields["item_text"] = e.newData.item_name;
              formFields["recur_days"] = null;
              formFields["recur_qty"] = null;

              console.log(data.appointmentpassword);
              if (data.appointmentpassword) {
                //data.is_dragappt Yoonus changed to appointmentpassword
                isDragConfirmation = true;
                this.setState({ formFields, isDragConfirmation });
              } else {
                isDragConfirmation = false;
                this.setState({ formFields, isDragConfirmation });
                this.handleDragandDropLogin();
              }
            }
          }
        });
    }
  };

  handleTocheckData = (e) => {
    console.log(e.appointmentData.status);
  };

  // handleToCloseModal
  handleAppointmentCloseModal = () => {
    this.setState({
      isAppointmentLogConfirmation: false,
    });
  };

  // handleauthentication

  handleauthentication = async (user, pass) => {
    let Body = {
      username: user,
      password: pass,
      type: "ApptBlock",
    };
    this.props
      .commonCreateApi(`userauthorizationpopup/`, Body)
      .then(async (key) => {
        let { status, data } = key;
        if (status == 200) {
          await this.setState((prevState) => ({
            isLoginConfirmation: !prevState.isLoginConfirmation,
          }));
          this.setState({ isOpenBlockModal: true });
        }
      });
  };

  handleLoginConfirmationDialog = async () => {
    await this.setState((prevState) => ({
      isLoginConfirmation: !prevState.isLoginConfirmation,
    }));
  };

  handleAppointmentStatusPopup = async () => {
    let { selectedDate, appointmentStatusDetails } = this.state;
    this.setState({
      openAppointmentStatusPopup: true,
    });

    const d = new Date(selectedDate);

    const year = d.getFullYear();
    const month = String(d.getMonth() + 1).padStart(2, "0");
    const day = String(d.getDate()).padStart(2, "0");

    const formattedDate = `${year}-${month}-${day}`;
    this.props
      .getCommonApi(
        `appointmentstatuscount/?from_date=${formattedDate}&to_date=${formattedDate}&site_code=${this.props.siteCode}`
      )
      .then((res) => {
        this.setState({
          appointmentStatusDetails: res,
          appointmentDate: formattedDate,
        });
      });
  };

  handleCloseStatusPopup = () => {
    this.setState({
      openAppointmentStatusPopup: false,
    });
  };

  handlePrint = async () => {
    try {
      const pdfBlob = await generateAppointmentStatusPDF(
        this.props.siteCode,
        this.state.appointmentDate,
        this.state.appointmentStatusDetails
      );
      const blobUrl = URL.createObjectURL(pdfBlob);
      const printFrame = document.createElement("iframe");
      printFrame.style.position = "absolute";
      printFrame.style.top = "-1000px";
      printFrame.style.left = "-1000px";
      printFrame.src = blobUrl;
      document.body.appendChild(printFrame);
      printFrame.onload = function () {
        try {
          printFrame.contentWindow.focus();
          if (printFrame.contentWindow.matchMedia) {
            const mediaQueryList = printFrame.contentWindow.matchMedia("print");
            mediaQueryList.addEventListener("change", function (mql) {
              if (!mql.matches) {
                document.body.removeChild(printFrame);
                URL.revokeObjectURL(blobUrl);
              }
            });
          }

          printFrame.contentWindow.print();
          setTimeout(() => {
            if (document.body.contains(printFrame)) {
              document.body.removeChild(printFrame);
              URL.revokeObjectURL(blobUrl);
            }
          }, 300000);
        } catch (e) {
          console.error("Print failed:", e);
          document.body.removeChild(printFrame);
          URL.revokeObjectURL(blobUrl);
        }
      };
    } catch (error) {
      console.error("Error generating PDF:", error);
      window.print();
    }
  };
  getPrintTime() {
    const now = new Date();
    return `Printed on: ${now.toLocaleString()}`;
  }

  render() {
    let {
      isOpenModal,
      isOpenBlockModal,
      appointmentId,
      isScrolled,
      SchedulerHeight,
      isOpenPrintModal,
      groupBy,
      siteList,
      branch_id,
      isTreatmentHistoryModal,
      isUpcomingAppointmentModal,
      customerNumber,
      visible,
      customerOption,
      selectedDate,
      isSettingsClick,
      dayName,
      passwordVisible,
      dragusername,
      dragpassword,
      isDragConfirmation,
      isSMSReply,
      contextMenuItems,
      target,
      disabled,
      isLoginConfirmation,
    } = this.state;
    let { filterDate, tokenDetail, t } = this.props;
    //console.log(SchedulerHeight);

    let AppointmentcellContent = (model) => {
      console.log(model, "model");
      //console.log(this.props.SchedulerSetting.is_dragappt);
      const { appointmentData } = model.data;
      console.log(appointmentData, "appointment");
      console.log(this.props.event, "appointmentEvent");
      console.log(this.props.event.length, "eventLength");
      // console.log(, "porpsSiteCode");
      console.log(this.props.siteCode, "propsItemSite");
      // Added by Santhosh
      //const isOpacity = appointmentData.itemsite_code == this.props.siteCode;
      const isOpacity = true;
      console.log(isOpacity, "isOpacity");
      let fromTime = getTime(appointmentData.startDate);
      let toTime = getTime(appointmentData.endDate);
      let borderStyle = "1px solid" + appointmentData.border_color;
      return (
        <div
          className="row"
          style={{
            height: "inherit",
            background: appointmentData.color,
            border: borderStyle,
            //opacity: isOpacity ? 1 : 0.5,
            opacity: 1,
            width: "100% !important",
            // cursor is commented to allow edit block appointments
            // cursor: isOpacity ? "pointer" : "not-allowed",
            // userSelect: isOpacity ? "auto" : "none",
          }}
        >
          {appointmentData.status && appointmentData.status === "Block" ? (
            <div className="d-flex">
              <div className="col-12 col-sm-12 col-md-12">
                <div className="app-detail">
                  {!isOpacity ? (
                    <p className="text-danger fs-16 font-weight-bold">
                      {" "}
                      {appointmentData.itemsite_code}
                    </p>
                  ) : (
                    ""
                  )}
                  <p>{appointmentData.reason}</p>
                  <p className="text-uppercase">
                    {/*appointmentData.text*/}
                    {appointmentData.appt_remark} ({fromTime}
                    {" - "}
                    {toTime})
                  </p>
                </div>
              </div>
            </div>
          ) : (
            <div className="d-flex">
              <div className="col p-0 ml-1">
                {appointmentData.link_flag ? (
                  <div className="pt-1">
                    <span className="tooltip-img">
                      <span>
                        <span>
                          <svg
                            width="15"
                            height="15"
                            viewBox="0 0 15 15"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <circle
                              cx="7"
                              cy="8"
                              r="7"
                              fill="rgba(60, 64, 135, 0.31)"
                              stroke="#3C4087"
                            ></circle>
                            <text x="5" y="12" fill="#3C4087">
                              L
                            </text>
                          </svg>
                        </span>
                      </span>
                      <div className="tooltiptext-img text-left">
                        <p>{`Linked Appointment`}</p>
                      </div>
                    </span>
                  </div>
                ) : (
                  ""
                )}
                {/*appointmentData.inital ? (
                  <div className="pt-1">
                    <span className="tooltip-img">
                      <img src={calander} />
                      <div className="tooltiptext-img text-left">
                        <p>
                          [{fromTime}
                          {" - "}
                          {toTime}]
                        </p>
                        <p>{appointmentData.cust_name}</p>
                        <p>{appointmentData.cust_refer}</p>
                        <p>{appointmentData.cust_phone}</p>
                        <p>{appointmentData.status}</p>
                      </div>
                    </span>
                  </div>
                ) : (
                  ""
                ) */}
                {appointmentData.sec_status_flag ? (
                  <div className="pt-1">
                    <span className="tooltip-img">
                      <img src={reschedule} width="100%" />
                      <span className="tooltiptext-img">
                        <p>{`Reschedule`}</p>
                      </span>
                    </span>
                  </div>
                ) : (
                  ""
                )}
                {appointmentData.whatsapp  == 1? (
                  <div className="pt-1">
                    <span className="tooltip-img">
                      <img src={whatsapp} />
                      <span className="tooltiptext-img">
                        <p>{`Whatsapp Reminder Sent`}</p>
                      </span>
                    </span>
                  </div>
                ) : (
                  ""
                )}
                {appointmentData.outstanding ? (
                  <div className="pt-1">
                    <span className="tooltip-img">
                      <img src={outstanding} />
                      <span className="tooltiptext-img">
                        <p>{`Outstanding $${appointmentData.outstanding_amt}`}</p>
                      </span>
                    </span>
                  </div>
                ) : (
                  ""
                )}
                {appointmentData.req_therapist ? (
                  <div className="pt-1">
                    <span className="tooltip-img">
                      <img src={req_therapist} />
                      <span className="tooltiptext-img">
                        <p>{`Request Therapist`}</p>
                      </span>
                    </span>
                  </div>
                ) : (
                  ""
                )}
                {appointmentData.balance && (
                  <div className="pt-1">
                    <span className="tooltip-img">
                      <img src={treatmentbal} />
                      <span className="tooltiptext-img">
                        <p>{`Have balance for Treatment or Product`}</p>
                      </span>
                    </span>
                  </div>
                )}
                {appointmentData.birthday ? (
                  <div className="pt-1">
                    <span className="tooltip-img">
                      <img src={birthday} />
                      <span className="tooltiptext-img">
                        <p>{`Birthday Month`}</p>
                      </span>
                    </span>
                  </div>
                ) : (
                  ""
                )}
                {appointmentData.remark ? (
                  <div className="pt-1">
                    <span className="tooltip-img">
                      <img src={new_remark} />
                      <span className="tooltiptext-img">
                        <p>{appointmentData.remark_val}</p>
                      </span>
                    </span>
                  </div>
                ) : (
                  ""
                )}

                {/* Yoonus block other than healspa */}
                {/* appointmentData.permanent_remark != "" ? (
                  <div className="pt-1">
                    <span className="tooltip-img">
                      <img src={permanent_remark} />
                      <span className="tooltiptext-img">
                        <p>{appointmentData.permanent_remark}</p>
                      </span>
                    </span>
                  </div>
                ) : (
                  ""
                ) */}

                {/* Yoonus block other than appleskin */}
                {/* appointmentData.cust_StoreCard ? (
                  <div className="pt-1">
                    <span className="tooltip-img">
                      <img src={storecard} />
                    </span>
                  </div>
                ) : (
                  ""
                ) */}
                {appointmentData.walkin ? (
                  <div className="pt-1">
                    <span className="tooltip-img">
                      <img src={walkin} />
                      <span className="tooltiptext-img">
                        <p>{`Walkin`}</p>
                      </span>
                    </span>
                  </div>
                ) : (
                  ""
                )}
              </div>

              <div className="app-detail col-11 col-sm-11 col-md-11 p-0 ml-2">
                {
                  // Added by Santhosh
                  !isOpacity ? (
                    <p className="text-danger fs-16 font-weight-bold">
                      {" "}
                      {appointmentData.itemsite_code}
                    </p>
                  ) : (
                    ""
                  )
                }
                <p>
                  {fromTime}
                  {" - "}
                  {toTime}
                </p>
                <p>{appointmentData.cust_name}</p>
                {/*<p>{appointmentData.cust_code}</p>*/}
                <p>
                  {appointmentData.cust_refer}&ensp;
                  {(appointmentData.gender &&
                    appointmentData.gender.toUpperCase().trim() == "M") ||
                  appointmentData.gender.toUpperCase().trim() == "MALE"
                    ? "M / "
                    : "/ "}
                  {appointmentData.age ? appointmentData.age : ""}
                </p>
                {/* Yoonus hide phone number for appleskin*/}
                {
                  <p>
                    {appointmentData.cust_phone}&nbsp;
                    {appointmentData.cust_phone1 ? "/" : ""}
                    &nbsp;{appointmentData.cust_phone1}
                  </p>
                }
                <p>{appointmentData.appt_remark}</p>
                <p>{appointmentData.permanent_remark}</p>
                <p>{appointmentData.consultant}</p>
                <p>{appointmentData.sec_status}</p>
                <p>{appointmentData.room}</p>
              </div>
            </div>
          )}
        </div>
      );
    };

    // handleCellAppointment
    // let handleCellAppointment = (data) => {
    //   return <div>{getTime(data.data.date)}</div>;
    // };
    return (
      // <div style={{ width: "100%", height: "100%" }}>
      <React.Fragment>
        {isOpenModal ? (
          <StaffSorting
            isOpenModal={isOpenModal}
            handleDialog={this.handleDialog}
            handleChange={this.handleChange}
            filterDate={filterDate}
          />
        ) : (
          ""
        )}
        {isOpenBlockModal && this.props.tokenDetail.flgallowblockappointment ? (
          <BlockPopup
            isOpenBlockModal={isOpenBlockModal}
            handleBlockDialog={this.handleBlockDialog}
            handleChange={this.handleChange}
            filterDate={filterDate}
            appointmentId={appointmentId}
          />
        ) : (
          ""
        )}
        {isOpenPrintModal ? (
          <PrintModal
            isOpenPrintModal={isOpenPrintModal}
            handlePrintDialog={this.handlePrintDialog}
          />
        ) : (
          ""
        )}

        {this.state.hideRow && (
          <div className="row">
            <div className="mb-3 col-12 col-sm-12 col-md-12 col-lg-12 col-xl-6 columnSixMediaQuery">
              <div className="row align-items-center">
                {this.props.meta ? (
                  <div
                    className={`col-4 col-sm-2 col-md-2 col-lg-2 col-xl-2 d-flex 
                  justify-content-start align-items-start
                  justify-content-center align-items-center`}
                  >
                    {this.props.meta.pagination &&
                    this.props.meta.pagination.total_pages > 1 ? (
                      <div className="d-flex">
                        <div className="row">
                          {this.props.meta.pagination.total_pages <
                            this.props.meta.pagination.current_page ||
                          this.props.meta.pagination.current_page > 1 ||
                          this.props.meta.pagination.total_pages ==
                            this.props.meta.pagination.current_page ? (
                            <button
                              className="cursor-pointer dx-button-content disabled mr-3"
                              onClick={this.handleBack}
                            >
                              <svg
                                width="9"
                                height="15"
                                viewBox="0 0 6 10"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <path
                                  d="M5 0.5L1 5L5 9.5"
                                  stroke="#888888"
                                  strokeLinecap="round"
                                  strokeLinejoin="round"
                                />
                              </svg>
                            </button>
                          ) : (
                            ""
                          )}
                          {/* <span className="dx-button-staff-content"> Staff </span> */}
                          {this.props.meta.pagination.total_pages >
                            this.props.meta.pagination.current_page &&
                          this.props.meta.pagination.total_pages !==
                            this.props.meta.pagination.current_page &&
                          this.props.meta.pagination.current_page > 0 ? (
                            <button
                              className="cursor-pointer dx-button-content"
                              onClick={this.handleNext}
                            >
                              <svg
                                width="9"
                                height="15"
                                viewBox="0 0 6 10"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <path
                                  d="M0.5 9.5L4.5 5L0.5 0.5"
                                  stroke="#888888"
                                  strokeLinecap="round"
                                  strokeLinejoin="round"
                                />
                              </svg>
                            </button>
                          ) : (
                            ""
                          )}
                        </div>
                        {/*
                  <div className={`ml-1 pt-0 ${isMobile ? "col-3" : "d-none"}`}> 
                    <img
                      style={{ width: 30 }}
                      onClick={
                        window.location.pathname ==
                        "/admin/newappointmentfullscreen"
                          ? this.handleFullScreenClose
                          : this.handleFullScreenOpen
                      }
                      className="close cursor-pointer tooltip-img ml-1"
                      src={fullscreenIcon}
                      alt=""
                      data-toggle="tooltip"
                      data-placement="bottom"
                      title={
                        window.location.pathname ==
                        "/admin/newappointmentfullscreen"
                          ? "Exit Fullscreen Mode"
                          : "Fullscreen Mode"
                      }
                    />
                  </div>
                  */}
                      </div>
                    ) : (
                      ""
                    )}
                  </div>
                ) : (
                  ""
                )}

                <div className="col-6 col-sm-2 col-md-2 col-lg-2 col-xl-2 paddingZero">
                  <NormalButton
                    mainbg={true}
                    className="fs-15 submit-btn"
                    label={`Today`}
                    outline={false}
                    onClick={() => {
                      this.handleDateChange(new Date());
                    }}
                  />
                </div>

                <div className="row col-12 col-sm-8 col-md-8 col-lg-8 col-xl-8 d-flex align-items-center">
                  <div className="col-12 col-sm-6 col-md-6 col-lg-6 col-xl-6 input-group my-2">
                    <NormalInput
                      placeholder="customer.."
                      value={this.state.custName}
                      name="custName"
                      onChange={this.handleSearchCustomer}
                      iconsVisible
                      onClickIcon={() => {
                        this.handleIconSearch();
                      }}
                    />
                    {/* <div className="d-flex w-100">
                    <NormalInput
                      className="col-11 "
                      placeholder="customer.."
                      value={this.state.custName}
                      name="custName"
                      onChange={this.handleSearchCustomer}
                      //onClick={this.handleClick}
                    />
                    <div
                      className="col-1 border-primary  cursor-pointer"
                      onClick={() => {
                        this.handleIconSearch();
                      }}
                    >
                      <IoSearchCircle color="#023f88" size={35} />
                    </div>
                  </div> */}
                  </div>
                  <div className="col-6 col-sm-3 col-md-3 col-lg-3 col-xl-3 paddingZero paddingRight4px">
                    <NormalButton
                      mainbg={true}
                      className="fs-14 w-100 p-1"
                      label="UCA"
                      onClick={this.handleUpcomingAppointment}
                    />
                  </div>
                  <div className="col-6 col-sm-3 col-md-3 col-lg-3 col-xl-3 paddingZero">
                    <NormalButton
                      mainbg={true}
                      className="fs-15 w-100"
                      label="History"
                      onClick={this.handleTreatmentHistory}
                    />
                  </div>
                </div>
              </div>
            </div>

            <div className="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-6 searchInputMediaQuery">
              <div className="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 paddingZero d-flex flex-wrap my-2 align-items-center newShedularRowGap">
                <div className="col-12 col-sm-4 col-md-4 col-lg-3 col-xl-4 mr-2 paddingZero">
                  <NormalInput
                    name="selecteddate"
                    value={
                      dayName[this.state.day] +
                      " " +
                      moment(selectedDate).format("DD/MM/YYYY")
                    }
                    disabled={true}
                  />
                </div>
                <NormalButton
                  mainbg={true}
                  className="confirm"
                  buttonClass="mr-2"
                  label={t("Snap")}
                  outline={false}
                  onClick={this.Snap}
                />
                <NormalButton
                  mainbg={true}
                  className=" confirm"
                  buttonClass="mr-2"
                  label={`Print`}
                  outline={false}
                  onClick={() => {
                    this.setState({ isOpenPrintModal: true });
                  }}
                />
                {
                  //Yoonus use same flag used for block appointment to use for this 30/08/2024
                  this.props.tokenDetail.flgallowblockappointment ? (
                  <NormalButton
                  mainbg={true}
                  className="confirm"
                  buttonClass="mr-2"
                  label={`Sort`}
                  outline={false}
                  onClick={() => {
                    this.setState({ isOpenModal: true });
                  }}
                  />
                  ) : (
                  ""
                  ) 
                }
                {
                  //Yoonus role_code 1 for Esthetic other "1" === "1"
                  //String(tokenDetail.role_code).toUpperCase() === "1" ? (
                  this.props.tokenDetail.flgallowblockappointment ? (
                    <NormalButton
                      mainbg={true}
                      className="fs-15 confirm"
                      buttonClass="mr-2"
                      label={`Block`}
                      outline={false}
                      onClick={() => {
                        this.props.tokenDetail.blockapptusernamepopup
                          ? this.setState({ isLoginConfirmation: true })
                          : this.setState({ isOpenBlockModal: true });
                      }}
                    />
                  ) : (
                    ""
                  )
                }
                {
                  <img
                    onClick={this.handleChange}
                    className="close cursor-pointer mr-2"
                    src={refresh}
                    alt=""
                    width="30"
                    height="30"
                  />
                }
                {/*<div className="col-md-4 col-12 py-2 py-lg-0">
                  <InputSearch
                    placeholder="Search here.."
                    value={this.state.searchtext}
                    onChange={this.handleSearch}
                    name="searchtext"
                  />
              </div>*/}
                {String(tokenDetail.role_code).toUpperCase() === "1" ? (
                  <img
                    onClick={this.handleSettingClick}
                    className="close cursor-pointer mr-2"
                    src={setting}
                    alt=""
                    width="30"
                    height="30"
                  />
                ) : null}

                {this.props.tokenDetail?.smsreply ? (
                  <div className="mr-2">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="30"
                      height="30"
                      fill="grey"
                      class="bi bi-chat-square-dots-fill"
                      viewBox="0 0 16 16"
                      onClick={this.handleSMSReply}
                    >
                      <path d="M0 2a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2h-2.5a1 1 0 0 0-.8.4l-1.9 2.533a1 1 0 0 1-1.6 0L5.3 12.4a1 1 0 0 0-.8-.4H2a2 2 0 0 1-2-2V2zm5 4a1 1 0 1 0-2 0 1 1 0 0 0 2 0zm4 0a1 1 0 1 0-2 0 1 1 0 0 0 2 0zm3 1a1 1 0 1 0 0-2 1 1 0 0 0 0 2z" />
                    </svg>
                  </div>
                ) : null}
                <div className="mr-2">
                  <img
                    style={{ width: 25 }}
                    onClick={
                      window.location.pathname ==
                      "/admin/newappointmentfullscreen"
                        ? this.handleFullScreenClose
                        : this.handleFullScreenOpen
                    }
                    className="close cursor-pointer tooltip-img mr-2"
                    src={fullscreenIcon}
                    alt=""
                    data-toggle="tooltip"
                    data-placement="bottom"
                    title={
                      window.location.pathname ==
                      "/admin/newappointmentfullscreen"
                        ? "Exit Fullscreen Mode"
                        : "Fullscreen Mode"
                    }
                  />
                </div>
              </div>
            </div>
          </div>
        )}

        <NormalModal
          className={"transaction-done-modal top-up-modal"}
          style={{
            minWidth: deviceWidth <= 1200 ? "95%" : "70%",
          }}
          mod
          modal={isSettingsClick}
          handleModal={this.handleSettingDialog}
        >
          <img
            onClick={this.handleSettingDialog}
            className="close cursor-pointer"
            src={closeIcon}
            alt=""
          />
          <AppointmentSettings
            handleModal={this.handleSettingDialog}
            handleSettingChange={this.props.handleAppointmentSetting}
          />
        </NormalModal>

        {isTreatmentHistoryModal ? (
          <TreatmentHistory
            isTreatmentHistoryModal={isTreatmentHistoryModal}
            handleTreatmentHistory={this.handleTreatmentHistory}
            customerNumber={this.state.customerNumber}
            custName={this.state.custName}
            custPhone={this.state.custPhone}
          />
        ) : (
          ""
        )}
        {isUpcomingAppointmentModal ? (
          <UpcomingAppointment
            isUpcomingAppointmentModal={isUpcomingAppointmentModal}
            handleUpcomingAppointment={this.handleUpcomingAppointment}
            customerNumber={this.state.customerNumber}
            custName={this.state.custName}
            custPhone={this.state.custPhone}
          />
        ) : (
          ""
        )}
        {visible ? (
          <div className="AppointmentnewStaffList">
            <div className="customerSearch-block">
              <div className="closeIconParent">
                <img
                  onClick={() => this.handleOutsideClick()}
                  className="close cursor-pointer close-flexEnd"
                  src={closeIcon}
                  alt=""
                />
              </div>
              <div className="d-flex mt-4 table table-header w-100 m-0 top-1">
                <div className="col-2">{t("Name")}</div>
                <div className="col-2">{t("Phone")}</div>
                <div className="col-2">{t("Customer Code")}</div>
                <div className="col-2">{t("Reference")}</div>
                <div className="col-3">{t("Email")}</div>
                <div className="col-1 d-none">{t("NRIC")}</div>
              </div>
              <div className="response-table w-100">
                {customerOption.length > 0 ? (
                  customerOption.map((item, index) => {
                    return (
                      <div
                        className="row m-0 table-body w-100 border"
                        onClick={() => this.handleSelectCustomer(item)}
                        key={index}
                      >
                        <div className="col-2">{item.cust_name}</div>
                        <div className="col-2">{item.cust_phone2}</div>
                        <div className="col-2">{item.cust_code}</div>
                        <div className="col-2">{item.cust_refer}</div>
                        <div className="col-3">{item.cust_email}</div>
                        <div className="col-1 d-none">{item.cust_nric}</div>
                      </div>
                    );
                  })
                ) : (
                  <div className="text-center w-100">
                    {t("No Data are available")}
                  </div>
                )}
              </div>
            </div>
          </div>
        ) : null}

        <NormalModal
          className={"transaction-done-modal top-up-modal"}
          style={{
            minWidth: "45%",
          }}
          mod
          modal={this.state.openAppointmentStatusPopup}
          handleModal={this.handleCloseStatusPopup}
        >
          <img
            onClick={this.handleCloseStatusPopup}
            className="close cursor-pointer"
            src={closeIcon}
            alt=""
          />
          <div id="printableArea" className="print-wrapper">
            <div className="d-flex justify-content-between mt-3">
              <h4>
                Appointment Status Count for {this.props.siteCode} in{" "}
                {this.state.appointmentDate}
              </h4>
            </div>
            <div
              className={`appt-details-main-container ${
                this.state.appointmentStatusDetails?.length > 14 ? "two-column" : ""
              }`}
            >
              {this.state.appointmentStatusDetails &&
                this.state.appointmentStatusDetails?.map((list, index) => {
                  return (
                    <div
                      key={index}
                      className="appt-details-container"
                      style={{
                        border: `1px solid ${list.border_color}`,
                        backgroundColor: list.color,
                      }}
                    >
                      {list.status} ({list.count})
                    </div>
                  );
                })}
            </div>
            <div className="print-timestamp" style={{ display: "none" }}>
              {this.getPrintTime()}
            </div>

            <div className="d-flex justify-content-end mt-3 no-print">
              <div className="col-3">
                <NormalButton
                  mainbg={true}
                  className="fs-15 submit-btn"
                  label={`Print`}
                  outline={false}
                  onClick={this.handlePrint}
                />
              </div>
            </div>
          </div>
        </NormalModal>

        <NormalModal
          className={"d-flex justify-content-center"}
          style={{ minWidth: "20%" }}
          modal={isLoginConfirmation}
          handleModal={() => {}}
        >
          <img
            onClick={this.handleLoginConfirmationDialog}
            className="close cursor-pointer"
            src={closeIcon}
            alt=""
          />
          <CredentialConfirmation
            handleLoginSubmit={(user, pass) =>
              this.handleauthentication(user, pass)
            }
          />
        </NormalModal>

        <NormalModal
          className={"d-flex justify-content-center"}
          style={{ minWidth: "20%" }}
          modal={isDragConfirmation}
          handleModal={this.handleDragConfirmationDialog}
        >
          <img
            onClick={this.handleDragConfirmationDialog}
            className="close cursor-pointer"
            src={closeIcon}
            alt=""
          />
          <div className="row">
            <div className="d-flex flex-wrap">
              <div className="col-12 mb-4">
                <p>{t("Please enter your login credential")} </p>
              </div>
              <div className="col-12 form-group mb-3 pb-2">
                <div className="input-group">
                  <NormalInput
                    placeholder="Username"
                    value={dragusername}
                    name="dragusername"
                    autocomplete="off"
                    onChange={this.handleInputChange}
                  />
                </div>
              </div>
              <div className="col-12 form-group mb-3 pb-2">
                <div className="input-group">
                  <NormalInput
                    type={passwordVisible ? "text" : "password"}
                    placeholder="Password"
                    value={dragpassword}
                    name="dragpassword"
                    autocomplete="off"
                    onChange={(e) => this.handleInputChange(e)}
                  />
                  <div className="input-group-addon right fs-14">
                    <span
                      onClick={() => this.toggle("passwordVisible")}
                      className={`icon-${
                        passwordVisible ? "eye" : "eye-blocked"
                      } cursor-pointer fs-24`}
                    ></span>
                  </div>
                </div>
              </div>
              <div className="form-group mb-0 p-0 d-flex justify-content-center col-12">
                <NormalButton
                  onClick={this.handleDragandDropLogin}
                  label="PROCEED"
                  className="col-12 submit-btn"
                />
              </div>
            </div>
          </div>
        </NormalModal>

        <div className={`col-md-12 mb-5 ${isSMSReply ? "" : "d-none"}`}>
          <SMSReply />
        </div>
        {console.log("CellDuration", this.props.SchedulerSetting.cell_duration)}

        <div
          class="dx-viewport demo-container schedule-container"
          ref={this.selectContainerRef}
        >
          <div
            className="select-container"
            ref={this.selectContainerRef}
            style={{ zIndex: this.state.zIndex }}
          >
            <NormalSelect
              name="branch"
              options={siteList}
              value={this.state.branch_id}
              onChange={this.handleSiteList}
              id={`branch`}
            />
          </div>
          <div
            className="appt-status-btn-container"
            ref={this.selectContainerRef}
            style={{ zIndex: this.state.zIndex }}
          >
            <NormalButton
              mainbg={true}
              className="fs-15 submit-btn"
              label={`Appt Status`}
              outline={false}
              onClick={() => {
                this.handleAppointmentStatusPopup();
              }}
            />
          </div>
          <Scheduler
            id="Scheduler"
            className="col-12 m-0 p-0 Scheduler"
            height={SchedulerHeight}
            dataSource={this.props.staffList.length > 0 ? this.props.event : []}
            // views={this.props.staffList.length > 0 ? views : Dayview}
            //views={isMobile ? mobileviews : views} //Yoonus turning it off

            onContentReady={(e) => {
              if (this.state.hideBtnStatus) {
                this.handleToAddBtn();
              }

              this.onContentReadyconfirmbook(
                e,
                this.props.rescheduleAppointmentData
              );
            }}
            // onContentReady={
            //   this.props.tokenDetail?.smsreply &&
            //   !this.props.tokenDetail?.confirmbook
            //     ? this.onContentReadysms
            //     : this.props.tokenDetail?.confirmbook &&
            //       !this.props.tokenDetail?.smsreply
            //     ? this.onContentReadyconfirmbook
            //     : this.props.tokenDetail?.confirmbook &&
            //       this.props.tokenDetail?.smsreply
            //     ? this.onContentReadyDouble
            //     : this.onContentReady
            // }
            defaultCurrentView="day"
            currentDate={selectedDate}
            defaultCurrentDate={new Date()}
            groups={this.props.staffList.length > 0 ? groups : []}
            // startDayHour={8}
            // endDayHour={21}
            // cellDuration={15}
            startDayHour={
              this.props.SchedulerSetting.startday_hour
                ? this.props.SchedulerSetting.startday_hour
                : 8
            }
            endDayHour={
              this.props.SchedulerSetting.endday_hour
                ? this.props.SchedulerSetting.endday_hour
                : 21
            }
            cellDuration={
              this.props.rescheduleFullScreenEnb === "true"
                ? 60
                : this.props.SchedulerSetting.cell_duration
                ? this.props.SchedulerSetting.cell_duration
                : 15
            }
            firstDayOfWeek={1}
            showAllDayPanel={false}
            crossScrollingEnabled={false}
            resourceCellComponent={ResourceCell}
            editing={
              this.props.SchedulerSetting.is_dragappt &&
              !this.props.tokenDetail.flgappointmentview
                ? {
                    allowDeleting: false,
                    allowResizing: true,
                    allowUpdating: true,
                    allowDragging: true,
                    allowTaint: true,
                  }
                : {
                    allowDeleting: false,
                    allowResizing: true,
                    allowUpdating: true,
                    allowDragging: false,
                    allowTaint: true,
                  }
            }
            onAppointmentClick={(e) => {
              e.cancel = true;
            }}
            onAppointmentDblClick={(e) => this.onAppointmentDblClick(e)}
            onCellClick={(e) => {
              if (!this.props.tokenDetail.flgappointmentview) {
                this.onEmptyClick(e);
                e.cancel = true;
              } else {
                e.cancel = true;
              }
            }}
            //dateSerializationFormat="yyyy-MM-ddTHH:mm:ssZ"
            appointmentComponent={AppointmentcellContent}
            onCurrentViewChange={this.handleViewChange}
            onCurrentDateChange={this.handleDateChange}
            appointmentDragging={{
              autoScroll: true,
              scrollSpeed: 25,
              group: { draggingGroupName },
              onDragStart: (e) => this.onDragStart(e),
              onDragEnd: (e) => this.onDragEnd(e),
            }}
            onCellContextMenu={(e) => {
              if (this.props.rescheduleId.appointmentId) {
                this.onCellContextMenu(e);
                e.cancel = true;
              } else {
                this.setState((state) => ({
                  ...state,
                  target: cellClassName,
                  disabled: false,
                  contextMenuItems: [],
                }));
                e.cancel = true;
              }
            }}
            onAppointmentUpdating={(e) => this.onAppointmentUpdated(e)}
            //scrolling={scrolling}
            //e.appointmentData.link_flag == false &&
            //Yoonus removing link_flag for rightclick ok
            onAppointmentContextMenu={
              (e) => {
                console.log(e, "eContextMenu");
                if (
                  e.appointmentData.status !== "Block" &&
                  !this.props.tokenDetail.flgappointmentview
                ) {
                  this.onAppointmentContextMenu(e);
                  e.cancel = true;
                } else {
                  this.setState((state) => ({
                    ...state,
                    target: appointmentClassName,
                    disabled: false,
                    contextMenuItems: [],
                  }));
                  e.cancel = true;
                }
              }
              // ({ appointmentData }) => {
              //   if (
              //     appointmentData.status &&
              //     appointmentData.status !== "Block"
              //   ) {
              //     this.onAppointmentContextMenu();
              //   }
              // }

              // appointmentData.status && appointmentData.status === "Block"
              //   ? ""
              //   : this.onAppointmentContextMenu
            }
            ref={this.scheduler}
            timeCellComponent={handleCellAppointment}
          >
            <View type="day" label={t("day")} />
            <View type="week" label="week" />
            <View type="month" label="month" />
            <Resource
              dataSource={this.props.staffList}
              fieldExpr="id"
              useColorAsDefault={true}
              allowMultiple={false}
            />
          </Scheduler>

          <ContextMenu
            dataSource={contextMenuItems}
            width={200}
            target={target}
            disabled={disabled}
            onItemClick={this.onContextMenuItemClick}
            itemRender={AppointmentMenuTemplate}
          />

          <NormalModal
            className={"d-flex justify-content-center"}
            style={{ minWidth: "20%" }}
            modal={this.state.isAppointmentLogConfirmation}
            handleModal={() => {}}
          >
            <img
              onClick={this.handleAppointmentCloseModal}
              className="close cursor-pointer"
              src={closeIcon}
              alt=""
            />
            <CredentialConfirmation
              handleLoginSubmit={(user, pass) =>
                this.handleReschedulePaste(user, pass)
              }
            />
          </NormalModal>
        </div>
      </React.Fragment>
    );
  }
}

const mapStateToProps = (state) => ({
  basicApptDetail: state.appointment.basicApptDetail,
  SchedulerSetting: state.appointment.SchedulerSetting,
  tokenDetail: state.authStore.tokenDetails,
  siteId: state.appointment.getSiteId,
  siteCode: state.appointment.getSiteCode,
  rescheduleId: state.rescheduleStore.rescheduleId,
  rescheduleAppointmentData: state.rescheduleStore.rescheduleAppointmentData,
  rescheduleFullScreenEnb: state.rescheduleStore.rescheduleFullScreenEnb,
  appointmentCustomerDetail: state.appointment.appointmentCustomerDetail,
  appointmentTreatmentList: state.appointment.appointmentTreatmentList,
});
const mapDispatchToProps = (dispatch) => {
  return bindActionCreators(
    {
      getCommonApi,
      commonPatchApi,
      commonCreateApi,
      getSiteId,
      getSiteCode,
      getRescheduleId,
      getRescheduleDataApi,
      getRescheduleFullScreenEnb,
    },
    dispatch
  );
};

export const NewSchedulerModal = withTranslation()(
  connect(mapStateToProps, mapDispatchToProps)(NewSchedulerModalClass)
);
